import { Navigate, useLocation } from 'react-router-dom';
import { EVENT_QUERY_PARAM, getStoredEventSlug } from '@/helpers/eventSlug';
import { INVITE_QUERY_PARAM, getStoredInviteToken } from '@/helpers/inviteToken';
import { TENANT_QUERY_PARAM, getStoredTenantSlug } from '@/helpers/tenantSlug';
import { useIsMobile } from '@/hooks/useIsMobile';
import { parseSelfieLocationState } from '@/Pages/Selfie/types/selfieLocationState';

type MobileOnlyGuardProps = {
  children: React.ReactNode;
};

function buildMobileRedirectSearch(location: ReturnType<typeof useLocation>): string {
  const searchParams = new URLSearchParams(location.search);
  const sessionFromState = parseSelfieLocationState(location.state);

  if (sessionFromState && !searchParams.has('sessionId')) {
    searchParams.set('sessionId', sessionFromState.sessionId);
  }

  // A URL de /mobile vira QR code aberto em outro aparelho — precisa carregar o
  // slug do tenant E o do evento para o funil não cair em 404 no celular.
  const tenantSlug = getStoredTenantSlug();
  if (tenantSlug !== null && !searchParams.has(TENANT_QUERY_PARAM)) {
    searchParams.set(TENANT_QUERY_PARAM, tenantSlug);
  }

  const eventSlug = getStoredEventSlug();
  if (eventSlug !== null && !searchParams.has(EVENT_QUERY_PARAM)) {
    searchParams.set(EVENT_QUERY_PARAM, eventSlug);
  }

  const inviteToken = getStoredInviteToken();
  if (inviteToken !== null && !searchParams.has(INVITE_QUERY_PARAM)) {
    searchParams.set(INVITE_QUERY_PARAM, inviteToken);
  }

  const search = searchParams.toString();
  return search === '' ? '' : `?${search}`;
}

export function MobileOnlyGuard({ children }: MobileOnlyGuardProps) {
  const isMobile = useIsMobile();
  const location = useLocation();

  if (!isMobile) {
    return (
      <Navigate
        to={{
          pathname: '/mobile',
          search: buildMobileRedirectSearch(location),
          hash: location.hash,
        }}
        replace
      />
    );
  }

  return children;
}
